import { Action } from 'redux'
import { ReservationModalActions } from '../../../reducers/bookingCalendar/actionNames'

const changeAdultsCount = (count): IChangeAdultsCount => ({
  count,
  type: ReservationModalActions.ChangeAdultsCount,
})

export interface IChangeAdultsCount
  extends Action<ReservationModalActions.ChangeAdultsCount> {
  count: number
}

export default changeAdultsCount
